import {BasicTable} from '@eitje/web_components'
import {COLUMNS} from './columns'
import {TABLE_TAXONOMY} from './constants'
import {buildRowData} from '~/components/basic_table/components/build_row_data'
import {ROW_FORMATS} from '~/components/basic_table/components/rows'
import '../../components/styles.less'

export const BillingInfosBasicTable = ({data}) => {
	const rowData = buildRowData(TABLE_TAXONOMY, data)

	return <BasicTable name="info_table" data={rowData} columns={COLUMNS} textRows={ROW_FORMATS} />
}
